import * as React from 'react';
import {PortfolioChartBase} from 'src/components/PortfolioChartBase';

type Props = {
  accountId: string;
};

export const AccountPortfolioChart = ({accountId}: Props) => {
  return (
    <PortfolioChartBase
      accountId={accountId}
      emptyMessage="Not enough snapshots for chart. Add more portfolio snapshots to see history."
    />
  );
};
